import { useShellStore } from "@/features/shell/stores/shellStore";
import { getOtpFlowStore } from "../stores/otpStore";
import type { OtpFlowName } from "../utils/types";
import { telemetry } from "utilities/telemetry";
import { otpFlowTracking } from "../utils/constants";
import { getChannelFromModal } from "../utils/getChannelFromModal";

const useOtpFlow = (flow: OtpFlowName) => {
  const store = getOtpFlowStore(flow);
  const setModal = useShellStore((s) => s.setModal);

  const clean = store((s) => s.clean);
  const forceCollapsedError = store((s) =>
    ["invalid", "locked"].includes(s.status),
  );

  const requestVerification = (modal: string = "phoneVerification") => {
    clean();
    setModal(modal);
  };

  const handleClose = () => {
    const { origin, channel } = otpFlowTracking[flow];
    telemetry.otpModalClosed({
      origin: origin,
      channel: getChannelFromModal(channel),
    });

    setModal(null);
  };

  return {
    forceCollapsedError,
    requestVerification,
    handleClose,
    store,
  };
};

export { useOtpFlow };
